import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function SeoPage() {
  return <ServiceDetailLayout slug="seo" />;
}
